import { Card, CardSection } from "tessa/cards";
import { IControlViewModel, ICardUIExtensionContext } from "tessa/ui/cards";
import { DotNetType, createTypedField,Visibility,Guid } from "tessa/platform";
import { CdDevelopmentScenarioSharedHelper }  from "./CdDevelopmentScenarioSharedHelper"
import {CdGeneralDocumentationClientHelper} from './CdGeneralDocumentationClientHelper';
import { GridViewModel, GridRowAction  } from "tessa/ui/cards/controls";
import { CdDocStates } from "../CdDocStates";

export class CdDevelopmentScenarioClientHelper extends CdGeneralDocumentationClientHelper {
 
  
  public static TableOrderLogic(card: Card, context: ICardUIExtensionContext) {    
    let edmSection = card.sections.tryGet('PkApprovementMatching');
    let pdciSection: CardSection | undefined = card.sections.tryGet('PkDocumentCommonInfo');
    if (pdciSection) {
      let stateID: number | null | undefined = pdciSection.fields.tryGet('StateID');
      if (edmSection &&
          stateID &&
          (stateID === CdDocStates.Draft.id ||
          stateID === CdDocStates.Rework.id)) {        

        let matchingControlViewModel: IControlViewModel | undefined = context.model.controls.get('Matching');
        if (matchingControlViewModel) {
          let controlViewModel = matchingControlViewModel as GridViewModel | null;
          if (controlViewModel) {
            
            //кнопки добавить\удалить.
            controlViewModel.rowInvoked.add(e => {
              if (e.action === GridRowAction.Deleting)
              { 
                if (e.row.tryGetField("RoleID")!.$value != CdDevelopmentScenarioSharedHelper.ApprovementRoles.VicePresidentID)
                {
                  e.cancel = true;
                  controlViewModel!.rows.forEach(row => {
                    let order = row.row.tryGetField("Order")!.$value;
                    let eorder = e.row.tryGetField("Order")!.$value;
                    if (order && row.rowId != e.row.rowId && order>=eorder)
                      row.row.set("Order",createTypedField(order+1, DotNetType.Int32))
                  });        
                }          
              }
              if (e.action === GridRowAction.Inserted){                  
                //e.cancel = true;
                let order = controlViewModel!.rows.length-2;
                e.row.set('RoleID', createTypedField(CdDevelopmentScenarioSharedHelper.ApprovementRoles.VicePresidentID, DotNetType.Guid));
                e.row.set('Order', createTypedField(order, DotNetType.Int32));
                e.row.set('RoleName',createTypedField(CdDevelopmentScenarioSharedHelper.ApprovementRoles.VicePresidentName, DotNetType.String));                 
              }

            });              
          }
        }
      }
    }    
  }
  
  public static ObjectLogic(context: ICardUIExtensionContext) {
    let card: Card = context.model.card;
    
    let objectField = context.model.controls.get("Object");            
    let investProjectNameField = context.model.controls.get("InvestProjectName");    
    let investProjectAddressField = context.model.controls.get("InvestProjectAddress");   
    let investProjectRegionField = context.model.controls.get("InvestProjectRegion");   
    let investProjectCountryField = context.model.controls.get("InvestProjectCountry");  

    let investProjectInfoSection: CardSection | undefined = card.sections.tryGet('PkInvestProjectInfo');
    let pkRdProperties: CardSection | undefined = card.sections.tryGet('PkRdProperties');
    if (!investProjectInfoSection || !pkRdProperties) return;
    let objectNotExist = investProjectInfoSection.fields.tryGetField("ObjectNotExist");       
    let countryId = investProjectInfoSection.fields.tryGetField("InvestProjectCountryID");       

    if (objectNotExist!=null && objectNotExist.$value == true){
      objectField!.controlVisibility = Visibility.Collapsed;
      pkRdProperties.fields.set("ObjectID",null);
      pkRdProperties.fields.set("ObjectName",null);      
      investProjectCountryField!.controlVisibility = Visibility.Visible;
      investProjectNameField!.controlVisibility = Visibility.Visible;
      investProjectAddressField!.controlVisibility = Visibility.Visible;
      if (countryId!=null && Guid.equals(countryId.$value,CdDevelopmentScenarioSharedHelper.Countries.RussiaID))
      {
        investProjectRegionField!.controlVisibility = Visibility.Visible;
      }
      else
      {
        investProjectInfoSection.fields.set("InvestProjectRegionID",null)
        investProjectInfoSection.fields.set("InvestProjectRegionName",null)
        investProjectRegionField!.controlVisibility = Visibility.Collapsed;
      }
    }
    else{      
      objectField!.controlVisibility = Visibility.Visible;
      investProjectInfoSection.fields.set("InvestProjectName",null);
      investProjectNameField!.controlVisibility = Visibility.Collapsed;
      investProjectInfoSection.fields.set("InvestProjectAddress",null);
      investProjectAddressField!.controlVisibility = Visibility.Collapsed;
      investProjectInfoSection.fields.set("InvestProjectRegionID",null);
      investProjectInfoSection.fields.set("InvestProjectRegionName",null);
      investProjectRegionField!.controlVisibility = Visibility.Collapsed;
      investProjectInfoSection.fields.set("InvestProjectCountryID",null);
      investProjectInfoSection.fields.set("InvestProjectCountryName",null);
      investProjectCountryField!.controlVisibility = Visibility.Collapsed;
    }

    investProjectInfoSection.fields.fieldChanged.add(e => {
        if (e.fieldName == "ObjectNotExist") 
        {
          if (!e) return;

          let investProjectInfoSection: CardSection | undefined = card.sections.tryGet('PkInvestProjectInfo');
          let pkRdProperties: CardSection | undefined = card.sections.tryGet('PkRdProperties');
          if (!investProjectInfoSection || !pkRdProperties) return;
  
          if (e.fieldValue == true){
            objectField!.controlVisibility = Visibility.Collapsed;
            pkRdProperties.fields.set("ObjectID",null);
            pkRdProperties.fields.set("ObjectName",null);      
            investProjectCountryField!.controlVisibility = Visibility.Visible;
            investProjectNameField!.controlVisibility = Visibility.Visible;
            investProjectAddressField!.controlVisibility = Visibility.Visible;
            let countryId = investProjectInfoSection.fields.tryGetField("InvestProjectCountryID");    
            if (countryId!=null && Guid.equals(countryId.$value,CdDevelopmentScenarioSharedHelper.Countries.RussiaID))
            {
              investProjectRegionField!.controlVisibility = Visibility.Visible;
            }
            else
            {
              investProjectInfoSection.fields.set("InvestProjectRegionID",null)
              investProjectInfoSection.fields.set("InvestProjectRegionName",null)
              investProjectRegionField!.controlVisibility = Visibility.Collapsed;
            }
          }
          else{          
            objectField!.controlVisibility = Visibility.Visible;
            investProjectInfoSection.fields.set("InvestProjectName",null);
            investProjectNameField!.controlVisibility = Visibility.Collapsed;
            investProjectInfoSection.fields.set("InvestProjectAddress",null);
            investProjectAddressField!.controlVisibility = Visibility.Collapsed;
            investProjectInfoSection.fields.set("InvestProjectRegionID",null);
            investProjectInfoSection.fields.set("InvestProjectRegionName",null);
            investProjectRegionField!.controlVisibility = Visibility.Collapsed;
            investProjectInfoSection.fields.set("InvestProjectCountryID",null);
            investProjectInfoSection.fields.set("InvestProjectCountryName",null);
            investProjectCountryField!.controlVisibility = Visibility.Collapsed;
          }
        }
        
        if (e.fieldName == "InvestProjectCountryID") 
        {
          if (Guid.equals(e.fieldValue,CdDevelopmentScenarioSharedHelper.Countries.RussiaID))
          {
            investProjectRegionField!.controlVisibility = Visibility.Visible;
          }
          else
          {  
            investProjectRegionField!.controlVisibility = Visibility.Collapsed;  
            let investProjectInfoSection: CardSection | undefined = card.sections.tryGet('PkInvestProjectInfo'); 
            if (!investProjectInfoSection) return;         
            investProjectInfoSection.fields.set("InvestProjectRegionID",null);
            investProjectInfoSection.fields.set("InvestProjectRegionName",null);
          }
        }
        
    });
  }

  public static FillApproversLogic(context: ICardUIExtensionContext) {
    let card: Card = context.model.card;
    let investProjectInfoSection: CardSection | undefined = card.sections.tryGet('PkInvestProjectInfo');
    let pkDevelopmentScenarioInfo: CardSection | undefined = card.sections.tryGet('PkDevelopmentScenarioInfo');
    let edRolesSection: CardSection | undefined = card.sections.tryGet('PkApprovementMatchingRoles');
    let edMatchingSection: CardSection | undefined = card.sections.tryGet('PkApprovementMatching');
   
    if (!investProjectInfoSection || !edRolesSection || !edMatchingSection || !pkDevelopmentScenarioInfo) return;

    investProjectInfoSection.fields.fieldChanged.add(async e => {
        if (e.fieldName !== "DirectionID") return;
        if (!e) return;
        {                  
          await CdDevelopmentScenarioClientHelper.FillApprovers(card);   
        }   
    });

    pkDevelopmentScenarioInfo.fields.fieldChanged.add(async e => {
      if (e.fieldName !== "DevelopmentScenarioTypeID") return;
      if (!e) return;
      {                  
        await CdDevelopmentScenarioClientHelper.FillApprovers(card);   
      }   
  });
  }    
}